import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ActiveAccountLayer from "../../../components/Admin/ActiveAccountLayer";

const ActiveAccount = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ActiveAccountLayer />
      </MasterLayout>
    </>
  );
};
export default ActiveAccount